import * as moment from 'moment-timezone';
import { formatTimeFromPresent } from '../shared/dateUtils';

export const getLiveStreamIcon = (livestreamable_type) => {
  if(livestreamable_type == "Session") {
    return "fa-podium-star"
  } else {
    return "fa-calendar-star"
  }
}

export const getLiveStreamImageUrl = (liveStream) => {
  if(liveStream.livestreamable_type == "Event") {
    return liveStream.livestreamable.image_url;
  } else {
    return liveStream.livestreamable.image_small;
  }
}

export const getModalActionButton = (type) => {
  if(type == "goback") {
    return "fa-arrow-left"
  } else {
    return "fa-times"
  }
}

export const getSurveyName = (survey) => {
  if(survey.surveyable_type == "Session") {
    return survey.surveyable.name
  } else {
    return survey.name
  }
}

export const getLiveStreamPath = (liveStream) => {
  if(["Embed", "Interactive", "Playback"].includes(liveStream.stream_type)) {
    return liveStream.web_embed_url;
  } else {
    return liveStream.link;
  }
}

export const getLiveStreamsSorted = (liveStreams) => {
  let pastLiveStreams = [];
  let liveStreamsNow = [];
  let upcomingLiveStreams = [];
  for (let index = 0; index < liveStreams.length; index++) {
    const liveStream = liveStreams[index];
    let startsAt = moment(liveStream.iso_starts_at).tz("America/New_York");
    let endsAt = moment(liveStream.iso_ends_at).tz("America/New_York");
    liveStream.formatted_starts_at = formatTimeFromPresent(liveStream.iso_starts_at)
    liveStream.formatted_ends_at = formatTimeFromPresent(liveStream.iso_ends_at)
    if(startsAt.isSameOrBefore() && endsAt.isAfter()) {
      liveStreamsNow.push(liveStream);
    } else if(startsAt.isAfter()) {
      upcomingLiveStreams.push(liveStream);
    } else {
      pastLiveStreams.push(liveStream);
    }
  }
  return {
    liveStreamsNow: liveStreamsNow,
    upcomingLiveStreams: upcomingLiveStreams,
    pastLiveStreams: pastLiveStreams
  }
}
